'use es6';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import NavMarker from 'react-rhumb/NavMarker';
import I18n from 'I18n';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIModal from 'UIComponents/dialog/UIModal';
import UISection from 'UIComponents/section/UISection';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import ReviewInput from '../components/ReviewInput';
import ReviewModalSuccess from '../components/ReviewModalSuccess';
import { closeReviewModal, submitReview } from '../actions/GoodsActions';
import { getCurrentUserEmail, getCurrentUserFullName } from '../selectors/auth';
import H2 from 'UIComponents/elements/headings/H2';
var ReviewModalContainer = createReactClass({
  displayName: "ReviewModalContainer",
  propTypes: {
    currentUserEmail: PropTypes.string,
    currentUserFullName: PropTypes.string.isRequired,
    goodId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    parentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    goodName: PropTypes.string.isRequired,
    closeReviewModal: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    pageOpenedFrom: PropTypes.string.isRequired,
    submitReview: PropTypes.func.isRequired,
    submitReviewStatus: PropTypes.string.isRequired,
    transactionId: PropTypes.number
  },
  render: function render() {
    var _this$props = this.props,
        currentUserEmail = _this$props.currentUserEmail,
        currentUserFullName = _this$props.currentUserFullName,
        goodName = _this$props.goodName,
        goodId = _this$props.goodId,
        open = _this$props.open,
        pageOpenedFrom = _this$props.pageOpenedFrom,
        parentId = _this$props.parentId,
        submitReviewStatus = _this$props.submitReviewStatus,
        transactionId = _this$props.transactionId;

    if (!open || !transactionId) {
      return null;
    }

    if (submitReviewStatus === RequestStatusTypes.SUCCEEDED) {
      return React.createElement(ReviewModalSuccess, {
        closeReviewModal: this.props.closeReviewModal
      });
    }

    return React.createElement(NavMarker, {
      name: "DETAIL_REVIEW_MODAL_LOAD"
    }, React.createElement(UIModal, {
      width: 500,
      className: "integrate-review-modal-input",
      "data-test-id": "review-modal"
    }, React.createElement(UIDialogHeader, null, React.createElement(UIDialogCloseButton, {
      onClick: this.props.closeReviewModal
    }), React.createElement(H2, {
      className: "m-all-0"
    }, I18n.text('reviewModal.header'))), React.createElement(UIDialogBody, null, React.createElement(UISection, null, React.createElement("p", {
      className: "m-bottom-0"
    }, React.createElement("strong", null, I18n.text('reviewModal.product'))), React.createElement("p", null, goodName)), React.createElement(ReviewInput, {
      currentUserEmail: currentUserEmail,
      currentUserFullName: currentUserFullName,
      goodId: goodId,
      parentId: parentId,
      pageOpenedFrom: pageOpenedFrom,
      submitReview: this.props.submitReview,
      submitReviewStatus: submitReviewStatus,
      transactionId: transactionId
    }))));
  }
});

function mapStateToProps(state) {
  return {
    currentUserEmail: getCurrentUserEmail(state),
    currentUserFullName: getCurrentUserFullName(state),
    goodId: state.reviewInputInfo.get('goodId'),
    goodName: state.reviewInputInfo.get('goodName'),
    open: state.reviewInputInfo.get('open'),
    parentId: state.reviewInputInfo.get('parentId'),
    submitReviewStatus: state.reviewInputInfo.get('submitReviewStatus'),
    transactionId: state.reviewInputInfo.get('transactionId')
  };
}

var mapDispatchToProps = {
  closeReviewModal: closeReviewModal,
  submitReview: submitReview
};
export default connect(mapStateToProps, mapDispatchToProps)(ReviewModalContainer);